// Module
var code = "<template> <div class=\"${verticalClass} ${horizontalClass}\"> <slot></slot> </div> </template>";
// Exports
export default code;